export default function FramePageContentWrapper(props) {
  const { children } = props;
  return (
    <div className="page-content-wrapper">
      <div
        className="page-content"
        id="pagecontentDiv"
        style={{ minHeight: "1030px" }}
      >
        {children}
      </div>
    </div>
  );
}
